<template>
	<div class="heroes">
		<div class="bg" v-bg="'heroes/bg.png'"></div>

		<transition name="boss">
			<div v-show="visible" class="boss">
				<div class="illustration" v-bg="'heroes/boss.png'"></div>
				<div class="bubble-wrap">
					<div class="bubble" v-bg="'heroes/bubble.png'">
						<div class="name" v-bg="'tooltip-title.png'">Zany</div>
						<div class="text" v-html="l('zany_sentence')"></div>
					</div>
				</div>
			</div>
		</transition>

		<transition-group name="portrait" class="portraits" tag="div" appear>
			<div v-for="hero in heroes" :key="hero.slug" class="portrait-wrap" v-hammer:tap="() => select(hero)" :class="{ locked: hero.locked, selected: hero === selected }">
				<portrait :hero="hero" />
			</div>
		</transition-group>

		<transition name="character" mode="out-in">
			<div v-if="selected" class="character" :key="selected.slug" :class="[ selected.slug, { locked: selected.locked } ]">
				<div class="shadow"></div>
				<div class="illustration">
					<div class="img" v-bg="'cards/hero/' + selected.slug + '-idle.png'"></div>
				</div>
			</div>
		</transition>

		<transition name="infos" mode="out-in">
			<div v-if="selected" class="infos" :key="selected.slug">
				<div class="bg" v-bg="'hero-infos.png'"></div>
				<div v-if="selected.locked" class="infos-content">
					<div class="name" v-bg="'tooltip-title.png'">???</div>
					<div class="locked-infos">
						{{ 'hero_locked_sentence' | lang }}
						<!-- {{ 'diamonds_left_1' | lang }} {{ selected.diamonds - user.diamonds }} {{ 'diamonds_left_2' | lang }} -->
					</div>
				</div>
				<div v-else class="infos-content">
					<div class="name" v-bg="'tooltip-title.png'">{{ selected[lang].name }}</div>
					<div class="stats">
						<ui-stat :value="selected.life" type="life" />
						<ui-stat :value="selected.attack" type="attack" />
						<ui-stat :value="selected.armor" type="armor" />
					</div>
					<div class="text">
						<ui-text :text="selected[lang].description" />
					</div>
					<ul class="features">
						<li v-for="(feature, index) in selected[lang].features" :key="index">{{ feature }}</li>
					</ul>
				</div>
			</div>
		</transition>


		<div v-if="selected" class="buttons">
			<ui-button :inactive="!playable" v-hammer:tap="play">{{ 'play' | lang }}</ui-button>
		</div>

		<div v-show="visible" class="back" v-hammer:tap="back"><</div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Portrait from '@/components/global/portrait'
import UiButton from '@/components/ui/ui-button'
import UiStat from '@/components/ui/ui-stat'
import UiText from '@/components/ui/ui-text'
import { generate_hero } from '@/js/board'
import { lang } from '@/js/lang'
import Sounds from '@/js/sounds'
import data_unlocks from '@/data/data_unlocks'

export default {
	name: 'heroes',
	data() {
		return {
			visible: false,
			heroes: [],
			selected: false
		}
	},
	computed: {
		...mapGetters([ 'lang', 'user' ]),
		playable() {
			return this.selected && !this.selected.locked
		}
	},
	methods: {
		l(str) {
			return lang(str)
		},
		back() {
			Sounds.play('button')
			this.$router.push({ name: 'home' })
		},
		select(hero) {
			Sounds.play('button')
			this.selected = this.selected === hero ? null : hero
		},
		play() {
			if (this.playable) {
				this.$store.dispatch('init_game', { hero: this.selected.slug })
				this.$nextTick(() => {
					this.$router.push({ name: 'game' })
				})
			}
		}
	},
	mounted() {
		setTimeout(() => {
			this.visible = true
			// this.select(this.heroes[0])
		}, 250)
	},
	created() {
		[ 'fish', 'spider', 'barrel', 'carrot', 'wolf' ].forEach((slug) => {
			const diamonds = data_unlocks.find(d => d.slug === slug && d.type === 'character').diamonds
			this.heroes.push({
				...generate_hero({ slug }),
				diamonds,
				locked: diamonds > this.user.diamonds
			})
		})
	},
	components: { UiButton, UiStat, UiText, Portrait }
}
</script>

<style lang="stylus" scoped>

.heroes
	height 100%
	flex center center column
	color #fff
	background-color #43333C
	.bg
		absolute 0
		background top center no-repeat
		background-size 1920px 1080px
	
	.boss
		position absolute
		right -32px
		bottom -8px
		z-index 1
		transition 0.25s easeOutQuart
		&.boss-enter
			transform translateX(64px)
			opacity 0
			.bubble-wrap
				transform translate(64px, 32px) scale(0.9)
				opacity 0
		.illustration
			width (517px / 1.1)
			height (909px / 1.1)
			background-size contain
		.bubble-wrap
			position absolute
			right 440px
			bottom 760px
			width (1375px / 1.7)
			height (427px / 1.7)
			transition 0.25s easeOutBack 0.15s
			.bubble
				absolute 0
				background-size contain
				text-align center
				flex center center
				padding 16px 32px 128px 32px
				color dark
				font-size 5rem
				line-height 0.8em
				animation bubble 10s infinite easeInOutSine alternate
				.name
					position absolute
					left 80px
					top -20px
					width round(393px / 2)
					height round(84px / 2)
					font-size 4rem
					background center center no-repeat
					background-size contain
	
	.portraits
		position absolute
		left 64px
		top 50%
		transform translateY(-50%)
		width 120px
		.portrait-wrap
			margin 0 0 24px 0
			transition 0.1s easeOutQuart
			&.portrait-enter
				transform translateX(-16px)
				opacity 0
			&.portrait-enter-active
				transition 0.25s easeOutBack
				&:nth-child(1)
					transition-delay 0.8s
				&:nth-child(2)
					transition-delay 0.9s
				&:nth-child(3)
					transition-delay 1s
				&:nth-child(4)
					transition-delay 1.1s
				&:nth-child(5)
					transition-delay 1.2s
			&:last-child
				margin 0
			&.locked >>> .portrait .illustration .img
				filter grayscale(100%) contrast(0%) brightness(0.35)
			&:hover
				transform scale(1.05)
			&.selected
				transform scale(1.1)
				>>> .portrait:after
					border-color #FFEFD9
		
	.character
		position absolute
		left 400px
		top 280px
		width (cell_width * 2)
		height (cell_height * 2)
		transform-origin bottom center
		transition 0.15s easeOutQuart
		&.character-leave-to
			transform translateX(-24px)
			opacity 0
		&.character-enter
			transform translateX(24px)
			opacity 0
		&.fish .illustration .img
			width round(584px / 1.7)
			height round(622px / 1.7)
			
		&.carrot .illustration .img
			width round(500px / 1.7)
			height round(836px / 1.7)

		&.barrel .illustration .img
			width round(661px / 1.7)
			height round(622px / 1.7)

		&.spider .illustration .img
			width round(523px / 1.7)
			height round(803px / 1.7)

		&.wolf .illustration .img
			width round(768px / 1.6)
			height round(734px / 1.6)
			transform translate(-72%, 16px)
		
		&.locked
			.illustration .img
				filter grayscale(100%) contrast(0%) brightness(0.35)
		.shadow
			position absolute
			left 10%
			right 10%
			bottom -12px
			height 48px
			border-radius 50%
			background-color alpha(#000, 25%)
			
		.illustration
			absolute 0
			flex flex-end center
			.img
				position absolute
				left 50%
				bottom 0
				transform translateX(-50%)
				width 100%
				height 100%
				background bottom center no-repeat
				background-size contain
	
	.infos
		position absolute
		left 940px
		top 320px
		width 350px
		height 550px
		transition 0.25s easeOutQuart
		flex center flex-start column
		&.infos-enter-active
			transition-delay 0.15s
		&.infos-enter
			transform translateX(-24px)
			opacity 0
		&.infos-leave-to
			transform translateX(24px)
			opacity 0
		.bg
			absolute 0
			background-size 100% 100%
		.infos-content
			absolute 0
			padding 56px 32px 64px 32px
			.locked-infos
				height 100%
				flex center center
				font-size 3.2rem
				text-align center
				padding 16px
			.name
				position absolute
				left 50%
				bottom calc(100% - 24px)
				width (393px / 2)
				height (84px / 2)
				background-size contain
				transform translateX(-50%)
				font-size 4rem
				color dark
				text-align center
				flex center center
			.stats
				flex center center
				margin 0 0 24px 0
				>>> .ui-stat
					margin 0 8px
			.text
				text-align center
				margin 0 0 24px 0
				font-size 3rem
			.features
				margin-left 32px
				li
					margin 0 0 12px 0
					&:last-child
						margin 0
			

	.buttons
		position absolute
		left 400px
		top 840px
		width (cell_width * 2)
		flex center center

	.back
		position absolute
		left 16px
		top 16px
		width 80px
		height 80px
		flex center center
		font-size 8rem
		background-color #fff
		color dark
		border-radius 50%
		padding-bottom 6px
		transition 0.1s easeOutQuart
		&:hover
			transform scale(1.2)
		&:active
			transform scale(1)


@keyframes bubble
	0%
		transform translate(-4px, -4px)
	100%
		transform translate(8px, 8px)

</style>
